import * as Yup from 'yup';
import { scopeSchema } from '@dashboard/components/DiscountsCoupons/couponScope';
import { amountOffValidation } from './amountOffValidation';

export const COUPON_STEPS = [{ label: 'Coupon' }, { label: 'Limit usage' }, { label: 'Review' }];

export const couponDetailsSchema = Yup.object().shape({
  label: Yup.string().required('Label is required'),
  code: Yup.string().required('Code is required'),
  discountType: Yup.string().required(),
  duration: Yup.string().required('Duration is required'),
  durationInMonths: Yup.number().when('duration', {
    is: duration => duration === 'repeating',
    then: Yup.number()
      .integer('Number of months must be a whole number')
      .min(1, 'Number of months must be at least 1')
      .typeError('Number of months must be at least 1')
      .required('Number of months is required when duration is repeating'),
  }),
  appliesToSetupFee: Yup.boolean(),
  appliesToTicketFees: Yup.boolean(),
  amountOff: amountOffValidation,
  percentOff: Yup.number()
    .nullable()
    .when('discountType', {
      is: 'percentOff',
      then: Yup.number()
        .moreThan(0, 'Must be greater than 0%')
        .max(100, 'Cannot exceed 100%')
        .typeError('Must be greater than 0%')
        .required('Must be greater than 0%'),
    }),
  currency: Yup.string().when('discountType', {
    is: 'amountOff',
    then: Yup.string().required('Currency is required when using amount off'),
  }),
});

const redemptionLimitsSchema = scopeSchema.shape({
  maxRedemptions: Yup.number().min(0, 'Max redemptions must be at least 0').nullable().optional(),
});

// Review checks everything again, so the create call never goes out with a field the
// merchant changed after leaving its step.
export const couponCreateSchema = couponDetailsSchema.concat(redemptionLimitsSchema);

export const getCouponStepSchema = step => {
  if (step === 1) return couponDetailsSchema;
  if (step === 2) return redemptionLimitsSchema;
  return couponCreateSchema;
};
